<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>
        lblCheckinTraversalLog
        <span class="font16 ml-3 text-dark float-none">
        </span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">
            ×
        </span>
    </button>
</div>
<div class="modal-body maxh400px" style="overflow: inherit !important;">
    <div class="popup-vcenter">
    <div class="">
        <div class="row">
          <div class="c12">
            <div class="card">
              <!-- Body Header -->
              <div class="card-header d-flex justify-content-between mx-2" translate>
              </div>
      
              <!-- Body Content -->
              <div class="table-responsive max-h500px" infinite-scroll [infiniteScrollDistance]="scrollDistance"
              [infiniteScrollThrottle]="throttle" [alwaysCallback]="true" [scrollWindow]="false" (scrolled)="loadMoreData($event)">
                <table class="tablest1">
                  <thead>
                    <tr>
                      <th scope="col" translate>#</th>
                      <th scope="col" translate>lblPageName</th>
                      <th scope="col" translate>lblTraversalDate</th>
                    </tr>
                  </thead>
      
                  <tbody>
                    <ng-container
                      *ngIf="
                      traversalList?.length > 0;
                        else load_NotFound_Template
                      "
                    >
                      <tr *ngFor="let item of traversalList; let i = index">
                        <td>
                          <ngb-highlight [result]="item.sequenceNumber">
                          </ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="item.pageName"> </ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="item.traversedDate | date : 'short'">
                          </ngb-highlight>
                        </td>
                      </tr>
                    </ng-container>
      
                    <ng-template #load_NotFound_Template>
                      <tr>
                        <td colspan="8" class="no-record" translate>
                          lblNoRecordsFound
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<div class="modal-footer justify-content-between">
</div>